var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-card',{staticClass:"box-card"},[_c('div',{staticClass:"chart-pie",attrs:{"id":_vm.chartId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }